import { render, staticRenderFns } from "./fanzha.vue?vue&type=template&id=274d042c&"
import script from "./fanzha.vue?vue&type=script&lang=js&"
export * from "./fanzha.vue?vue&type=script&lang=js&"
import style0 from "./fanzha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fanzha.vue"
export default component.exports